import { PositionsCard } from "@/routes/processes/[processId]/htz/work-orders/[workOrderId]/positions/_components/positions-card";
import { useParams } from "react-router";
import { useGetWorkOrder } from "@/routes/processes/[processId]/htz/work-orders/[workOrderId]/_components/use-work-order-offline";
import { PositionsTableSkeleton } from "@/services/backend/htz/position/components/positions-table";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function PositionsRoute() {
  const { workOrderId } = useParams();
  const { data: workOrder, isLoading, error } = useGetWorkOrder(workOrderId!);

  if (isLoading) {
    return <PositionsTableSkeleton />;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!workOrder) {
    return null;
  }

  return <PositionsCard workOrder={workOrder} />;
}
